<template>
  <div>
    <Card :bordered="false" shadow>
      <div class="mb-3">
        <DatePicker
          :value="dateSelect"
          type="date"
          placeholder="選擇日期"
          style="width: 120px"
          :clearable="false"
          format="yyyy-MM-dd"
          @on-ok="traderecord"
          @on-change="(event) => (dateSelect = event)"
          confirm
          class="mr-1"
        ></DatePicker>
        <Select v-model="searchState" style="width: 120px" class="mr-1">
          <Option
            v-for="item in searchSelect"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          v-model="pageSize"
          style="width: 120px"
          @on-change="traderecord"
        >
          <Option
            v-for="item in pageSizeList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <lida-table
        :propscolumns="tableThead"
        :data="items"
        :sortStatus="false"
        :propsPageSize="20"
        :SpinLoading="SpinLoading"
      ></lida-table>
    </Card>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapGetters } from 'vuex';
export default {
  name: "traderecord",
  data () {
    return {
      SpinLoading: true,
      dateSelect: "",
      pageSize: '1000',
      pageSizeList: [
        { label: '1000筆', value: '1000' },
        { label: '全部', value: '0' }
      ],
      searchState: "1",
      searchSelect: [
        { value: "1", label: "赔率变化", keys: ['date', 'datetime', 'chname', 'ip', 'action', 'betplace', 'oldvalue', 'newvalue', 'diff'] },
        { value: "2", label: "停押纪录", keys: ['date', 'datetime', 'chname', 'action', 'oldvalue', 'newvalue'] },
        { value: "3", label: "营运站点管理", keys: ['date', 'datetime', 'chname', 'chuser', 'mlevel', 'action', 'oldvalue', 'newvalue'] },
        { value: "4", label: "开关盘纪录", keys: ['date', 'datetime', 'chname', 'oldvalue', 'newvalue'] },
        { value: "5", label: "开奖结果", keys: ['date', 'datetime', 'chname', 'action', 'oldvalue', 'newvalue'] },
        { value: "6", label: "系统设定", keys: ['datetime', 'chname', 'action', 'oldvalue', 'newvalue'] },
        { value: "7", label: "补货设定", keys: ['datetime', 'chname', 'chuser', 'action', 'oldvalue', 'newvalue'] },
        { value: "10", label: "注单变更纪录", keys: ['datetime', 'chname', 'ip', 'action', 'oddsname', 'oldvalue', 'newvalue'] },
        { value: "11", label: "RTP设定", keys: ['datetime', 'chname', 'ip', 'action', 'oldvalue', 'newvalue'] },
        // { value: "11", label: "自开彩设定相关", keys: ['datetime', 'chname', 'ip', 'oldvalue', 'newvalue', 'action'] }
      ],
      items: [],
      theadData: {
        date: {
          title: '期数日期',
          key: 'date',
          align: 'center',
          render: (h, params) => h('span', params.row.datetime.split(' ')[0])
        },
        datetime: {
          title: '时间',
          key: 'datetime',
          align: 'center',
          render: (h, params) => h('span', params.row.datetime.split(' ')[1])
        },
        chname: {
          title: '操作者名称',
          key: 'chname',
          align: 'center'
        },
        ip: {
          title: 'IP',
          key: 'ip',
          align: 'center'
        },
        action: {
          title: '投注选项',
          key: 'action',
          align: 'center'
        },
        betplace: {
          title: '盘口',
          key: 'betplace',
          align: 'center'
        },
        oldvalue: {
          title: '变动前值',
          key: 'oldvalue',
          align: 'center'
        },
        newvalue: {
          title: '变动后值',
          key: 'newvalue',
          align: 'center'
        },
        diff: {
          title: '变动值',
          key: 'diff',
          align: 'center'
        },
        chuser: {
          title: '变动帐号',
          key: 'chuser',
          align: 'center'
        },
        mlevel: {
          title: '用户级别',
          key: 'mlevel',
          align: 'center',
          render: (h, params) => {
            let levelText = ''
            switch (params.row.mlevel) {
              case '0':
                levelText = '总控'
                break;
              case '1':
                levelText = '公司'
                break;
              case '9':
                levelText = '操作员'
                break;
              default:
                break;
            }
            return h('span', levelText)
          }
        },
        oddsname: {
          title: '变动原因',
          key: 'oddsname',
          align: 'center'
        },
      }
    };
  },
  created () {
    this.dateSelect = moment().format("YYYY-MM-DD")
    this.traderecord();
  },
  computed: {
    ...mapGetters(["getgameid"]),
    tableThead () {
      const result = {}
      let tableKeys = this.searchSelect.filter(word => word.value == this.searchState);
      tableKeys[0].keys.forEach(res => {
        result[res] = this.theadData[res]
      });
      return Object.assign({}, result)
    }
  },
  watch: {
    searchState: 'traderecord',
    getgameid: 'traderecord'
  },
  methods: {
    async traderecord () {
      this.SpinLoading = true
      try {
        const res = await this.$axios.traderecord.list(this.searchState, this.dateSelect, this.pageSize)
        if ('status' in res && res.status === 0) return
        this.items = res
      } catch (error) {
        console.error(error);
      } finally {
        this.SpinLoading = false
      }
    }
  }
};
</script>
